<template>
  <sa-page-layout :btnRefreshVisible="true" :btnNewVisible="true" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh" class="sa-no-space">
    <template slot="table-body">
      <div class="sa-page-attivita-bacheca">
        <b-row style="overflow: auto">
          <b-col cols="12" xs="12" sm="9" md="9" lg="9" xl="9" class="sa-page-attivita-bacheca-col-bacheca">
            <div style="height: 100%; overflow: auto; align-items: center">
              <b-card header="" header-tag="header" footer-tag="footer" title="">
                <template #header>
                  <h4 class="header-title mt-0 mb-3">
                    <i class="bi bi-clipboard2-fill"></i>
                    Bacheca
                  </h4>
                </template>
                <b-row>
                  <b-col v-for="item in items" :key="item.id" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="getColor(item)" style="min-height: 220px">
                      <b-row class="text-right">
                        <b-col cols="12">
                          <b-icon icon="pencil" @click="onClickEditCard(item)" style="margin-right: 5px" />
                          <b-icon icon="lock" />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12">
                          <router-link class="sa-edit-link" :to="'/attivita/bacheca/view/' + item.id"> {{ item.titolo }}</router-link>
                          <hr />
                          <span class="sa-data">{{ item.nota.slice(0, 356) }}</span>
                          <br />
                          <a class="sa-data" v-if="readMoreActivated && item.nota.length > 350" href="#" @click="onLeggiTuttoClick(item)">Leggi tutto...</a>
                        </b-col>
                      </b-row>
                    </div>

                    <!-- <b-card :bg-variant="getColor(item)" border-variant="dark" text-variant="white" class="text-center">
                                <template #header>
                                    <router-link class="sa-edit-link" :to="'/attivita/bacheca/view/' + item.id"> {{ item.titolo }}</router-link>
                                </template>
                                <b-card-text>{{ item.nota.slice(0, 356) }}</b-card-text>
                                <a class="sa-data" v-if="readMoreActivated && item.nota.length > 350" href="#" @click="onLeggiTuttoClick(item)">Leggi tutto...</a>
                            </b-card> -->
                    <br />
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </b-col>
          <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3" class="sa-page-attivita-bacheca-col-attivita">
            <div style="height: 100%; overflow: auto; align-items: center">
              <b-card header="" header-tag="header" footer-tag="footer" title="">
                <template #header>
                  <h4 class="header-title mt-0 mb-3">
                    <i class="bi bi-journal-bookmark-fill"></i>
                    Attivita
                  </h4>
                </template>
                <ul class="timeline2">
                  <li v-for="item in attivitaOptions" :key="item.id" class="event" data-date="25 Maggio 2021 | 10:30">
                    <span class="mdi mdi-circle pal"></span>
                    <span class="sa-timeline-date">{{ formatDateTime(item.dataAttivita) }}</span>
                    <h3>
                      <a style="font-size: 1.2rem" href="#" onclick="return false;" @click="onClickAttivita(item)">{{ item.titoloAttivita }}</a>
                    </h3>
                    <span class="sa-data">{{ item.descrizione }}</span>
                  </li>
                </ul>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-modal ref="mdlNote" id="mdlNote" :title="titoloNotaSelezionata" hide-footer>
        <span class="sa-data">{{ notaSelezionata }}</span>
      </b-modal>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
export default {
  components: { SaPageLayout },
  mixins: [UtilityMixin],
  data() {
    return {
      pathResource: "/attivitabacheca",
      filtro: {},
      items: [],
      rows: null,
      perPage: 100,
      currentPage: 1,
      linkedit: "/attivita/bacheca",
      showModalLoading: false,
      readMoreActivated: true,
      titoloNotaSelezionata: "",
      notaSelezionata: "",
      attivitaOptions: [
        { id: 1, titoloAttivita: "Attività Uno", descrizione: "Descrizione Attività Uno", dataAttivita: 1688637195 },
        { id: 2, titoloAttivita: "Attività Due", descrizione: "Descrizione Attività Due", dataAttivita: 1688637195 },
        { id: 3, titoloAttivita: "Attività Tre", descrizione: "Descrizione Attività Tre", dataAttivita: 1688637195 },
        { id: 4, titoloAttivita: "Attività Quattro", descrizione: "Descrizione Attività Quattro", dataAttivita: 1688637195 },
        { id: 5, titoloAttivita: "Attività Cinque", descrizione: "Descrizione Attività Cinque", dataAttivita: 1688637195 },
        { id: 6, titoloAttivita: "Attività Sei", descrizione: "Descrizione Attività Sei", dataAttivita: 1688637195 },
        { id: 7, titoloAttivita: "Attività Sette", descrizione: "Descrizione Attività Sette", dataAttivita: 1688637195 },
        { id: 8, titoloAttivita: "Attività Otto", descrizione: "Descrizione Attività Otto", dataAttivita: 1688637195 },
        { id: 9, titoloAttivita: "Attività Nove", descrizione: "Descrizione Attività Nove", dataAttivita: 1688637195 },
        { id: 10, titoloAttivita: "Attività Dieci", descrizione: "Descrizione Attività Dieci", dataAttivita: 1688637195 },
        { id: 11, titoloAttivita: "Attività Undici", descrizione: "Descrizione Attività Undici", dataAttivita: 1688637195 },
        { id: 12, titoloAttivita: "Attività Dodici", descrizione: "Descrizione Attività Dodici", dataAttivita: 1688637195 },
        { id: 13, titoloAttivita: "Attività Tredici", descrizione: "Descrizione Attività Tredici", dataAttivita: 1688637195 },
        { id: 14, titoloAttivita: "Attività Quattordici", descrizione: "Descrizione Attività Quattordici", dataAttivita: 1688637195 },
      ],
    };
  },
  mounted() {
    let me = this;
    //me.$refs["SaPageList"].show();
    let sessionStorage = window.sessionStorage;
    if (sessionStorage["filtro"]) {
      me.filtro = JSON.parse(sessionStorage["filtro"]);
    }
    me.loadData();
  },
  watch: {
    currentPage() {
      let me = this;
      me.loadData();
    },
  },
  methods: {
    loadData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource;
      me.filtro.page = me.currentPage;
      me.filtro.forPage = me.perPage;
      me.showModalLoading = true;
      axios
        .get(link, { params: me.filtro })
        .then((response) => {
          me.items = [];
          me.rows = response.data.data.recordsNumber;
          me.items = response.data.data.list;
          console.log(me.items);
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    getColor(item) {
      let returnValue = "callout callout-success";
      switch (item.priorita) {
        case "BASSA":
          returnValue = "callout callout-success";
          break;
        case "MEDIA":
          returnValue = "callout callout-warning";
          break;
        case "ALTA":
          returnValue = "callout callout-danger";
          break;
      }
      return returnValue;
    },
    onClickEditCard(item) {
      let me = this;
      me.$router.replace("/attivita/bacheca/edit/" + item.id).catch((err) => {
        err;
      });
    },
    onRefresh() {
      let me = this;
      me.loadData();
    },

    onLeggiTuttoClick(item) {
      let me = this;
      me.titoloNotaSelezionata = "Note " + item.titolo;
      me.notaSelezionata = item.nota;
      me.$refs.mdlNote.show();
    },
    onClickAttivita(item) {
      console.log(item);
    },
  },
};
</script>
<style scoped>
.callout a:hover {
  color: black;
}
.sa-page-attivita-bacheca-col-bacheca {
  background-color: transparent;
  display: flex;
  max-height: 100%;
  flex-direction: column;
  padding-right: 0px;
  padding-left: 0px;
}

.sa-page-attivita-bacheca {
  /* background-color: var(--bg-sidebar); */
  height: 100%;
  padding-left: 8px;
  padding-right: 8px;
}
.sa-page-attivita-bacheca .row {
  height: 100%;
}

.sa-page-attivita-bacheca-col-attivita {
  margin-bottom: 0px;
  padding-bottom: 15px;
  padding-right: 0px;
}
@media (max-width: 450px) {
  .sa-page-attivita-bacheca-col-attivita {
    max-height: 380px;
  }
}
@media screen and (min-width: 450px) and (max-width: 1024px) {
  .sa-page-attivita-bacheca-terapia-attiva {
    max-height: 33px;
  }
  .sa-page-attivita-bacheca-col-attivita {
    height: calc(100% - 7px);
  }
}

@media screen and (min-width: 1024px) {
  .sa-page-attivita-bacheca-col-attivita {
    height: calc(100% - 7px);
    /* background-color: blue; */
  }
}
</style>
